
import React from 'react'
export const logotipo = <img className="nav-panel-logo" width={40} src={require('../svg/logotipo.png')} />
export const logoHome = <img className="nav-panel-logo" width={350} src={require('../svg/homelogo.png')} />
export const working = <img className="nav-panel-logo" width={350} src={require('../svg/working.png')} />
export const colorNavBar = () => '#fff';